import {create} from 'zustand';

type AutofilledFieldsStore = {
  fields: string[];
  setFields: (fields: string[]) => void;
};

export const useAutofilledFieldsStore = create<AutofilledFieldsStore>(set => ({
  fields: [],
  setFields: fields => set({fields}),
}));
